import { render, staticRenderFns } from "./CustomerEmailAccessList.vue?vue&type=template&id=99cd9e2a&"
import script from "./CustomerEmailAccessList.vue?vue&type=script&lang=js&"
export * from "./CustomerEmailAccessList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('99cd9e2a')) {
      api.createRecord('99cd9e2a', component.options)
    } else {
      api.reload('99cd9e2a', component.options)
    }
    module.hot.accept("./CustomerEmailAccessList.vue?vue&type=template&id=99cd9e2a&", function () {
      api.rerender('99cd9e2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/security/customer-email-access/CustomerEmailAccessList.vue"
export default component.exports